<div class="c-cms-form" sk-field="{{field.fieldName}}">
    <div class="form-flex">
        <div class="form-label"></div>
        <div class="form-value">
            <div class="form-row u-pt8">
                <div class="form-row">
                    <label class="c-form-checkbox">
                        <input type="checkbox" name={{field.fieldName}}
                               skf-change="$parent.changePolicy('{{field.fieldName}}')"
                               skf-checked="$field.isSelected"/>
                        <span class="checkbox-icons"></span>
                        <span class="checkbox-text">
                        {{each field.privacyPolicyTitle}}
                            {{$value}}
                            {{if $index < field.privacyPolicyTitle.length - 1}}
                            <br/>
                            {{/if}}
                        {{/each}}
                        <a class="form-policy goto-link" href="{{field.privacyPolicyUrl}}" target="_blank">{{field.privacyPolicyUrlTitle}}</a>
                        </span>
                    </label>
                </div>
            </div>
            <div class="form-error" skf-if="$field.dirty && $field.invalid" skf-text="$field.validationMessage">{{field.validationMessage}}</div>
        </div>
    </div>
</div>